import * as XLSX from "xlsx";
import { getWorksheet } from "./getWorksheet";

const getMissingHeaders = (firstRowString: string, requiredHeaders: string[]) => {
  const trimmedFirstRow = firstRowString.trim();

  const headers = trimmedFirstRow.split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
  const missingHeaders = requiredHeaders.filter(
    requiredHeader => headers.indexOf(requiredHeader) === -1
  );

  return missingHeaders;
};

export const validateFile = (evt: ProgressEvent<FileReader>, requiredHeaders: string[]) => {
  const firstRowWorkSheet = getWorksheet(evt, 1);
  const firstRowString = XLSX.utils.sheet_to_csv(firstRowWorkSheet);

  const missingHeaders = getMissingHeaders(firstRowString, requiredHeaders);

  const worksheetWithInfoRow = getWorksheet(evt, 2);
  const isEmpty = !worksheetWithInfoRow.A2;

  return { missingHeaders, isEmpty };
};
